import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/api";

// Module-level set prevents React Strict Mode's double-invoke from exchanging
// the same one-time code twice (the second attempt would always fail with 400
// because the code is single-use and already consumed by the first attempt).
const attemptedCodes = new Set();

const AuthHandler = () => {
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== "/auth/callback") {
      return;
    }

    const completeGoogleAuth = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) {
        navigate("/login", { replace: true });
        return;
      }

      if (attemptedCodes.has(code)) {
        return;
      }
      attemptedCodes.add(code);

      try {
        const { data } = await api.post("/auth/google/exchange", { code });
        if (!data?.user) {
          throw new Error("Missing user payload from OAuth exchange.");
        }

        login(data.user);
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Failed to exchange Google OAuth code:", error);
        navigate("/login", { replace: true });
      }
    };

    completeGoogleAuth();
  }, [location, navigate, login]);

  return null;
};

export default AuthHandler;
